// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-q_gq","galleryItem_borderTopRadius":"c-q_gr","galleryItem__image":"c-q_gs"};